<script lang="ts">
  import WorkOrderSummaryTag from "../../../../../../../../../../../../../../_shared/_modules/work-order-summary-tag"
  import type { WorkOrderSummaryTagPresentation } from "../../../../../../../../../../../../../../_shared/_logic/summary-tag"
  import { buildWorkOrderTableSummaryTag } from "../../../../../../../../_shared/_logic/work-order-table-tags"

  let {
    workOrder = null,
    tag = null,
    label = "",
    subLabel = "",
    orderNumber = "",
    orderTypeLabel = "",
    disabled = false,
  }: {
    workOrder?: WorkOrder | null
    tag?: WorkOrderSummaryTagPresentation | null
    label?: string | null
    subLabel?: string | null
    orderNumber?: string | number | null
    orderTypeLabel?: string | null
    disabled?: boolean
  } = $props()

  const presentation = $derived(
    buildWorkOrderTableSummaryTag({
      workOrder,
      tag,
      label,
      subLabel,
      orderNumber,
      orderTypeLabel,
    }),
  )
</script>

<WorkOrderSummaryTag tag={presentation} {disabled} />
